<template>
  <div class="navbar-container">
    <app-event></app-event>
    <div class="navbar-logo">
      <img alt="Nuance logo" :src="currentLogoPath" class="navbar-image" @click="toggleAbout" />
    </div>
    <div class="navbar-links">
      <template v-if="!user">
        <button class="navbar-button" @click="$emit('open-login')">log in</button>
        <button class="navbar-button1" @click="$emit('open-signup')">sign up</button>
        <span class="navbar-link" @click="toggleAbout">about</span>
      </template>
      <template v-else>
        <span class="navbar-link" @click="$emit('open-profile')">profile</span>
        <span class="navbar-separator">-</span>
        <span class="navbar-link" @click="toggleAbout">about</span>
      </template>
    </div>
  </div>
</template>

<script>
import AppEvent from "./event";
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';

export default {
  name: "Navbar",
  props: {
    logo_path: {
      type: String,
      default: '/playground_assets/logo.png',
    },
    showAbout: {
      type: Boolean,
      default: false
    },
    inProfile: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AppEvent,
  },
  data() {
    return {
      user: null,
      screenWidth: window.innerWidth
    }
  },
  created() {
    onAuthStateChanged(auth, user => {
      this.user = user;
    });
    // Add window resize listener
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // Remove window resize listener
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    toggleAbout () {
      if (!this.showAbout) {
        this.$emit("open-about");
      } else {
        this.$emit("close-about")
      }
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
    }
  },
  computed: {
    currentLogoPath() {
      // Use white logo only when header background is black (mobile)
      if (this.screenWidth <= 768) {
        return '/playground_assets/logo-white.svg';
      }
      return this.logo_path;
    }
  }
};
</script>

<style scoped>
.navbar-container {
  top: 1;
  width: 100%;
  display: flex;
  z-index: 10000;
  align-items: center;
  padding-top: var(--dl-space-space-unit);
  padding-bottom: var(--dl-space-space-unit);
  justify-content: center;
  position: relative;
  background-color: #fff;
  /* Add blur effect for modal overlay */
  backdrop-filter: blur(8px);
}

.sticky {
  position: fixed;
}

.navbar-logo {
  width: 120px;
  position: absolute;
  cursor: pointer;
}
.navbar-image {
  width: 100%;
  height: 100%;
}
.navbar-links {
  display: flex;
  gap: 0rem;
  align-items: center;
  position: absolute;
  right: 10px;
}
.navbar-link {
  font-family: Syne;
  font-size: .75rem;
  cursor: pointer;
  text-decoration: underline;
  color: #000;
}
.navbar-separator {
  font-family: Syne;
  font-size: .75rem;
  color: #000;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.navbar-button {
  color: #ffffff;
  font-family: Syne;
  border-width: 2px;
  padding-left: var(--dl-space-space-unit);
  border-radius: 0px;
  padding-right: var(--dl-space-space-unit);
  background-color: #000000;
  margin-left: 0.5rem;
  font-size: 0.75rem;
  padding-top: 0;
  padding-bottom: 0;
  cursor: pointer;
}
.navbar-button1 {
  color: #000000;
  font-size: 0.75rem;
  border-width: 1px;
  font-family: Syne;
  padding-top: 0.2vw;
  border-color: #000;
  border-width: 1px;
  padding-left: var(--dl-space-space-unit);
  border-radius: 0px;
  padding-right: var(--dl-space-space-unit);
  padding-bottom: 0rem;
  background-color: transparent;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  cursor: pointer;
}
.navbar-button[data-v-07602a60], .navbar-button1[data-v-07602a60] {
  cursor: pointer;
  }
.navbar-button[data-v-07602a60] {
  font-size: 14px;
  margin-left: 0;
  border: none;
  background: #000;
  color: #fff;
  padding: 0.2rem 1.2rem;
  font-family: Syne, sans-serif;
  font-weight: 400;
  cursor: pointer;
  }
.navbar-button1[data-v-07602a60] {
  font-size: 0.75rem;
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
  border: 2px solid #000;
  background: #fff;
  color: #000;
  font-family: Syne, sans-serif;
  font-weight: 400;
  cursor: pointer;
  }
.navbar-links[data-v-07602a60] {
  gap: 0;
  display: flex;
  align-items: center;
  }
.navbar-button[data-v-07602a60]:active, .navbar-button1[data-v-07602a60]:active {
  outline: none;
  box-shadow: none;
  }
@media (max-width: 767px) {
  .navbar-links {
    right: 10px;
    gap: 0.5rem;
  }
}
@media (max-width: 768px) {
  .navbar-link {
    display: none;
  }
  .navbar-separator {
    display: none;
  }
  .navbar-button,
  .navbar-button1 {
    display: none;
  }
  .navbar-container {
    background-color: #000;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .navbar-logo {
    width: 120px;
  }
}
</style>
